import { ChartOptions, ChartTooltipOptions } from 'chart.js'
import { ContractType } from '../types'

interface BarChartTooltipOptions extends ChartTooltipOptions {
  yAlign?: string
  xAlign?: string
}

export interface BarChartOptions extends Omit<ChartOptions, 'tooltips'> {
  showBoltTooltip?: boolean
  tooltips?: BarChartTooltipOptions
}

export enum EnergyType {
  ELECTRICITY = 'electricity',
  GAS = 'gas'
}

export enum BuyerType {
  PRIVATE = 'private',
  COMPANY = 'company'
}

export enum RegionType {
  FLA = 'fla',
  WAL = 'wal',
  BRU = 'bru'
}

export enum ViewportType {
  MOBILE = 'mobile',
  DESKTOP = 'desktop'
}

export enum DonutChartFeaturedDataType {
  ALL = 'all',
  BOLT = 'bolt',
  GOVERNMENT = 'government',
  PRODUCER = 'producer',
  GAS = 'gas'
}

export type DonutChartProps = {
  featuredData?: DonutChartFeaturedDataType
  responsiveLabels?: boolean
  noLabels?: boolean
  contractType?: ContractType
}
